import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "invariant-gate" }
const _hoisted_2 = {
  key: 0,
  class: "spinner-border",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "flex-grow-1" }
const _hoisted_4 = { class: "fw-bold fs-5" }
const _hoisted_5 = { class: "small" }
const _hoisted_6 = { class: "text-end small" }
const _hoisted_7 = { class: "badge bg-success" }
const _hoisted_8 = { class: "badge bg-danger ms-1" }
const _hoisted_9 = { class: "badge bg-secondary ms-1" }
const _hoisted_10 = {
  key: 0,
  class: "badge bg-light text-dark ms-1"
}
const _hoisted_11 = { class: "text-muted mt-1" }
const _hoisted_12 = { class: "list-group mb-3" }
const _hoisted_13 = { class: "d-flex align-items-start gap-2" }
const _hoisted_14 = { class: "flex-grow-1" }
const _hoisted_15 = { class: "inv-cab" }
const _hoisted_16 = {
  key: 0,
  class: "badge bg-dark ms-1",
  title: "El gate devolvió esta invariante y el índice de la consola no la conocía. Se pinta igual."
}
const _hoisted_17 = {
  key: 0,
  class: "mb-0 mt-1 small violations"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 2,
  class: "text-muted small mt-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["gate-light d-flex align-items-center gap-3 p-3 mb-3 rounded", 
        _ctx.running ? 'gate-running' : _ctx.gate && _ctx.gate.ok ? 'gate-green' : 'gate-red'
      ])
    }, [
      (_ctx.running)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : (_openBlock(), _createElementBlock("i", {
            key: 1,
            class: _normalizeClass(["fas fa-2x", _ctx.gate && _ctx.gate.ok ? 'fa-circle-check' : 'fa-circle-xmark'])
          }, null, 2)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.running
              ? "CORRIENDO LAS INVARIANTES…"
              : _ctx.gate && _ctx.gate.ok
              ? "INVARIANTES EN VERDE"
              : "INVARIANTES EN ROJO"), 1),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.running)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" El informe anterior se borró: ninguna tiene veredicto todavía. ")
              ], 64))
            : (_ctx.gate && _ctx.gate.ok)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.okNote), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _cache[0] || (_cache[0] = _createElementVNode("strong", null, "NO se descongela.", -1)),
                  _cache[1] || (_cache[1] = _createTextVNode(" El runbook dice rollback. ", -1))
                ], 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.conteo.pass) + " pasan", 1),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.conteo.fail) + " fallan", 1),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.conteo.pending) + " sin verificar", 1),
          (_ctx.conteo.porCorrer)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.conteo.porCorrer) + " por correr", 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.pie), 1)
      ])
    ], 2),
    _createElementVNode("div", _hoisted_12, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
        return (_openBlock(), _createElementBlock("div", {
          key: row.id,
          class: _normalizeClass(["list-group-item py-2", `fila-${row.estado}`])
        }, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("i", {
              class: _normalizeClass(["fas mt-1", _ctx.iconoDe(row)])
            }, null, 2),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("strong", null, _toDisplayString(row.id), 1),
                _createTextVNode(" — " + _toDisplayString(row.title) + " ", 1),
                (row.fueraDelIndice)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, "extra"))
                  : _createCommentVNode("", true)
              ]),
              (row.estado === 'fail')
                ? (_openBlock(), _createElementBlock("ul", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shown(row), (v, i) => {
                      return (_openBlock(), _createElementBlock("li", { key: i }, [
                        _createElementVNode("code", null, _toDisplayString(v), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (row.estado === 'fail' && _ctx.violaciones(row).length > _ctx.VISIBLE)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-link btn-sm p-0 mt-1",
                    onClick: ($event: any) => (_ctx.toggle(row.id))
                  }, _toDisplayString(_ctx.expanded[row.id]
                  ? "ver menos"
                  : `ver las ${_ctx.violaciones(row).length - _ctx.VISIBLE} restantes`), 9, _hoisted_18))
                : _createCommentVNode("", true),
              (row.estado === 'pending')
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(row.result && row.result.pendingReason), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["badge align-self-center", _ctx.chipDe(row).clase])
            }, _toDisplayString(_ctx.chipDe(row).texto), 3)
          ])
        ], 2))
      }), 128))
    ])
  ]))
}